import {
    PAYROLL_REQUEST,
    PAYROLL_SUCCESS,
    PAYROLL_FAILURE,
} from "../../enums/Payroll/payroll";

export const payrollRequest = () => ({type: PAYROLL_REQUEST});
export const payrollSuccess = (payload) => ({type: PAYROLL_SUCCESS, payload});
export const payrollFailure = (payload) => ({type: PAYROLL_FAILURE, payload});